import type {
  ApplyBatchAtLevelType,
  BatchLevelConfigType,
  GetAvailableBatchesAtLevelType
} from "./BatchLevelsType";

const getAvailableBatchesAtLevel: GetAvailableBatchesAtLevelType = (
  allBatches,
  selectedBatches,
  level,
) => {
  const excluded = selectedBatches.slice(0, level); // batches selected at highest level
  return allBatches.filter((b) => !excluded.includes(b.key));
};

export const getBatchLevelConfig: BatchLevelConfigType = (
  allBatches,
  selectedBatches,
  level,
) => {
  const availableListDropdown = getAvailableBatchesAtLevel(
    allBatches,
    selectedBatches,
    level,
  );
  const canExpand =
    level + 1 < allBatches.length &&
    getAvailableBatchesAtLevel(allBatches, selectedBatches, level + 1).length >
      0;
  return {
    availableListDropdown,
    canExpand,
    isFinal: !canExpand,
  };
};

export const applyBatchAtLevel: ApplyBatchAtLevelType = (prev, level, batch) => { // when changing batch dropdown list returns to new selected batch
  const next = prev.slice(0, level);
  next[level] = batch;
  return next;
};